import { Controller } from "@hotwired/stimulus"

// Scroll-spy for the Documentation page TOC. As each section scrolls into the
// viewport's reading zone, marks its matching anchor in the sidebar active.
//
// Targets:
//   - link:    each `.doc-toc-link` <a> in the sidebar (href is "#doc-…")
//   - section: each `<section id="doc-…">` in the main column
export default class extends Controller {
  static targets = ["link", "section"]

  connect() {
    if (!("IntersectionObserver" in window)) return

    this.linkById = {}
    this.linkTargets.forEach(a => {
      const href = a.getAttribute("href") || ""
      if (href.startsWith("#")) this.linkById[href.slice(1)] = a
    })

    this.observer = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return
        const link = this.linkById[entry.target.id]
        if (!link) return
        this.linkTargets.forEach(l => l.classList.remove("is-active"))
        link.classList.add("is-active")
      }),
      { rootMargin: "-15% 0px -75% 0px", threshold: 0 }
    )

    this.sectionTargets.forEach(s => this.observer.observe(s))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }
}
